import React from 'react'
import { useIntl } from 'react-intl'

import { IS_WEB } from '../../constants'
import { tID } from '../../utils/utils'
import { GenericModalWrapper } from '../genericModalWrapper/GenericModalWrapper'
import { INACTIVITY_STATE, InactivityTimeout } from '../inactivityTimeout/InactivityTimeout'

export interface InactivityWarningModalProps {
  visible: boolean
  onRequestClose: () => void
  warningDuration: number
  onPressResume: () => void
  onPressSignIn: () => void
  onPressSignOut: () => void
  onWarningTimeUp: () => void
  onPressClose?: () => void
  inactivityState?: INACTIVITY_STATE
  animationType?: 'none' | 'slide' | 'fade'
}

export const InactivityWarningModal: React.FunctionComponent<InactivityWarningModalProps> = ({
  visible,
  onRequestClose,
  warningDuration,
  onPressResume,
  onPressSignIn,
  onPressSignOut,
  onWarningTimeUp,
  onPressClose,
  inactivityState,
  animationType = 'fade',
}) => {
  const { formatMessage } = useIntl()

  return (
    <GenericModalWrapper
      isOpen={visible}
      onClose={onPressClose ?? onRequestClose}
      content={
        <InactivityTimeout
          warningDuration={warningDuration}
          onPressResume={onPressResume}
          onPressSignIn={onPressSignIn}
          onPressSignOut={onPressSignOut}
          onWarningTimeUp={onWarningTimeUp}
          isWeb={IS_WEB}
          inactivityState={inactivityState}
        />
      }
      closeIconTestID={tID('InactivityTimeout-close')}
      accessibilityLabel={formatMessage({
        defaultMessage: 'Inactivity warning modal',
        description: 'Accessibility label for inactivity warning modal',
      })}
      testID={tID('InactivityWarningModal')}
      animationType={animationType}
    />
  )
}
